const SELECTORS = {
    block: '.wp-block-list.is-style-table-of-contents',
};

export function initTableOfContentsList (block) {
    const observerCallback = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                const activeLink = block.querySelector(`a[href="#${id}"]`);
                
                // Clean up old active classes
                block.querySelectorAll('li').forEach(li => li.classList.remove('active'));
                
                // Add to current
                if (activeLink) {
                    activeLink.parentElement.classList.add('active');
                }
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, {
        root: null,
        rootMargin: '0px',
    });

    // Only observe elements that have a matching link in this TOC block
    block.querySelectorAll('a[href^="#"]').forEach(link => {
        const id = link.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (target) observer.observe(target);
    });
}

export function TableOfContentsList () {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initTableOfContentsList(block);
    });
}